import { passesRoleGate } from '../../../utils/roles';
import type { FeatureKey } from '../../../services/entitlementsService';

export interface MenuGate {
  requiredRoles?: string[];
  hiddenRoles?: string[];
  /** Funcionalidades del paquete que debe tener la cuenta (todas). Mientras cargan, el ítem no se pinta. */
  requiredFeatures?: FeatureKey[];
}

export function isMenuItemVisible(
  item: MenuGate,
  role: string | undefined,
  hasFeature: (feature: FeatureKey) => boolean
): boolean {
  const userRole = role?.toLowerCase();
  if (item.hiddenRoles && userRole && item.hiddenRoles.map((r) => r.toLowerCase()).includes(userRole)) {
    return false;
  }
  if (item.requiredRoles && item.requiredRoles.length > 0 && !passesRoleGate(userRole, item.requiredRoles)) {
    return false;
  }
  if (item.requiredFeatures?.some((feature) => !hasFeature(feature))) {
    return false;
  }
  return true;
}
